var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.editPanel.optType === "new" &&
      _vm.editPanel.panelInfo.nodeType === "panel"
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { height: "40px" }, attrs: { span: 18 } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "new" },
                      model: {
                        value: _vm.inputType,
                        callback: function ($$v) {
                          _vm.inputType = $$v
                        },
                        expression: "inputType",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("panel.custom")) + "\n      ")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "new_outer_template" },
                      model: {
                        value: _vm.inputType,
                        callback: function ($$v) {
                          _vm.inputType = $$v
                        },
                        expression: "inputType",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("panel.import_template")) + "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "new_inner_template" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.getTree($event)
                        },
                      },
                      model: {
                        value: _vm.inputType,
                        callback: function ($$v) {
                          _vm.inputType = $$v
                        },
                        expression: "inputType",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("panel.copy_template")) + "\n      ")]
                  ),
                ],
                1
              ),
              _vm.inputType === "new_outer_template"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "el-icon-upload",
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.goFile },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("panel.upload_template")) + "\n      "
                          ),
                        ]
                      ),
                      _c("input", {
                        ref: "files",
                        attrs: {
                          id: "input",
                          type: "file",
                          accept: ".DET",
                          hidden: "",
                        },
                        on: { change: _vm.handleFileChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "5px" } },
        [
          _c("el-col", { attrs: { span: 4 } }, [
            _vm._v(
              _vm._s(_vm.editPanel.titleSuf) + _vm._s(_vm.$t("commons.name"))
            ),
          ]),
          _c(
            "el-col",
            { attrs: { span: 20 } },
            [
              _c("el-input", {
                attrs: { clearable: "", size: "mini" },
                model: {
                  value: _vm.editPanel.panelInfo.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.editPanel.panelInfo, "name", $$v)
                  },
                  expression: "editPanel.panelInfo.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.inputType === "new_inner_template"
        ? _c(
            "el-row",
            { staticClass: "preview" },
            [
              _c(
                "el-col",
                {
                  staticStyle: { height: "100%", "overflow-y": "auto" },
                  attrs: { span: 8 },
                },
                [
                  _c("template-all-list", {
                    attrs: { "template-list": _vm.templateList },
                    on: {
                      showCurrentTemplateInfo: _vm.showCurrentTemplateInfo,
                    },
                  }),
                ],
                1
              ),
              _c("el-col", {
                staticClass: "preview-show",
                style: _vm.classBackground,
                attrs: { span: 16 },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.inputType === "new_outer_template"
        ? _c("el-row", { staticClass: "preview", style: _vm.classBackground })
        : _vm._e(),
      _c(
        "el-row",
        { staticClass: "root-class" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("commons.cancel")) + "\n    ")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "mini",
                disabled: !_vm.saveStatus,
              },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("commons.confirm")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }